import { state } from '../state'

/**
 * Select a sort option and emit the sort event
 * @param {string|number} itemId - The ID of the selected sort option
 * @param {Object} option - The sort option configuration
 * @param {Function} emitSort - Function to emit the sort event
 */
export const selectSortItem = (itemId, option, emitSort) => {
  // If selecting the same sort item again, toggle direction
  if (state.selectedSort.value === itemId) {
    // Get the selected item from the options
    const item = option.items.find(item => item.id === itemId)
    
    // Emit sort event with the appropriate direction
    if (item.direction === 'ASC') {
      emitSort({ key: itemId, order: 'DESC' })
      item.direction = 'DESC' // Update the item's direction
    } else {
      emitSort({ key: itemId, order: 'ASC' })
      item.direction = 'ASC' // Update the item's direction
    }
  } else {
    // New sort selection
    state.selectedSort.value = itemId
    
    // Get default direction or use 'ASC'
    const selectedItem = option.items.find(item => item.id === itemId)
    const direction = selectedItem?.direction || 'ASC'
    
    // Emit sort event
    emitSort({ key: itemId, order: direction })
  }
  
  // Close the menu after selection
  state.openMenu.value = null
}

/**
 * Reset the sort selection
 * @param {Function} emitSort - Function to emit the sort event
 */
export const resetSort = (emitSort) => {
  state.selectedSort.value = null
  emitSort({ key: '', order: '' })
}
